/*** IMPORTS FROM imports-loader ***/
var define = false;

var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

